export default "/acfdf2704e412c85fb550b6408622629b62bf7b2/48c3d350a874654b9919fc00f7ab5f35.png";